<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="reserve04">
            <reserve-header :reserve_type="'lodge'" :reserve_target="'reserve'"></reserve-header>
            <!-- {{ lodge_node_category_group }} -->
            <!-- <div v-if="mgw_phase_production_001">
                <div class="fullContainer">
                    {{ word_chg('宿泊予約をする') }}
                </div>
            </div> -->
            <!-- {{ reserve_step }} -->
            <div v-if="reserve_step == 500">
                <div class="customContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev(1)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">プランを選択</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="customContainer" v-for="(node) in reserve_node" :key="node">
                    <!-- {{ node }} -->
                    <ul class="reserve05__reserves border-bottom mb-3">
                        <li class="reserve05__reserve" >
                            <h3 class="reserve05__title mb-4">
                                {{ node.category_group_label }}
                            </h3>
                            <div class="row" v-if="sprm.consecutive_cnt > 0">
                                <div class="col-4 text-end" v-html="word_chg_html('チェックインS')"></div>
                                <div class="col-8">{{ sprm.date }}</div>
                                <div class="col-4 text-end" v-html="word_chg_html('チェックアウトS')"></div>
                                <div class="col-8">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>
                            <div class="row" v-else-if="sprm.consecutive_cnt == 0">
                                <div class="text-center">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>
                        </li>
                    </ul>
                    <div class="row mb-3 pb-3 border-bottom border-dark" v-for="a in 3" :key="a">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">【お試しホテルステイ】年中楽しめるオールシーズンプール完備！全室オーシャンビュー＜食事なし＞</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                ¥90,000
                            </div>
                        </div>
                        <div class="col-3">
                            <img src="https://www.img-ikyu.com/contents/common/image/acc6/00002956/1/org/12488903.jpg?auto=compress,format&lossless=0&w=560&h=370">
                        </div>
                        <div class="col-6">
                            <p style="font-size: 1.3rem;">
                                早期予約75日前】空港から約20分の好立地<br>全室オーシャンビューのビーチリゾート<br>朝食付
                            </p>
                        </div>
                        <div class="col-3 text-end">
                            <span :class="plan_class(node.id, a)" @click="selectPlan(node.id, a)">{{ word_chg(plan_btn_label(node.id, a)) }}</span>
                        </div>
                    </div>
                    <div class="row mb-3 pb-3 border-bottom border-dark">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">部屋のみのご予約</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                ¥90,000
                            </div>
                        </div>
                        <div class="col-12 text-end">
                            <span :class="plan_class(node.id, 0)" @click="selectPlan(node.id, 0)">{{ word_chg(plan_btn_label(node.id, 0)) }}</span>
                        </div>
                    </div>
                </div>
                <div class="customContainer">
                    <div>
                        <p 
                            v-if="chk_selected_plan"
                            class="reserve-stay-reserve-inner__reserve border-bottom border-dark pb-4">
                            <button class="button02" @click="selectedPlanNext()">{{ word_chg('予約を進める') }}</button>
                        </p>
                        <p class="reserve04__button" v-else>
                            {{ word_chg('プランを選択してください。') }}
                        </p>
                    </div>
                </div>
            </div>
            <div v-else-if="reserve_step == 10">
                <!-- {{ PlanContents }} -->
                <!-- {{ get_relations_from_category_group }} -->
                <div class="fullContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev((production_chk)? 1: 100000)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">{{ sprm.date }}</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                    <div class="py-4">
                        <br>
                        <span class="text-danger">※</span>{{ word_chg('は必須項目です。') }}
                    </div>
                </div>
                <div class="customContainer mb-4 ">
                    <!-- PlanContents -->
                    <div class="row mb-3 pb-3 border-bottom border-dark" v-if="typeof get_plan_obj(target_plan) === 'object'">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">{{ get_plan_obj(target_plan).subject }}</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                {{ get_plan_obj(target_plan).price_head_label }}
                            </div>
                        </div>
                        <div class="col-3">
                            <img src="https://www.img-ikyu.com/contents/common/image/acc6/00002956/1/org/12488903.jpg?auto=compress,format&lossless=0&w=560&h=370">
                        </div>
                        <div class="col-9">
                            <p style="font-size: 1.3rem;white-space: pre-line;">
                                {{ get_plan_obj(target_plan).body }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="customContainer">
                    <ul class="reserve05__reserves border-bottom mb-3">
                        <li class="reserve05__reserve" v-for="(node, node_index) in reserve_node" :key="node">
                            <h3 class="reserve05__title mb-4">
                                {{ node.category_group_label }}
                            </h3>
                            {{get_checkin_date_price_type_price_value(node.category_group_id, get_node_members_use_num(node_index))}}
                            <div class="row" v-if="sprm.consecutive_cnt > 0">
                                <div class="col-4 text-end" v-html="word_chg_html('チェックインS')"></div>
                                <div class="col-8">{{ sprm.date }}</div>
                                <div class="col-4 text-end" v-html="word_chg_html('チェックアウトS')"></div>
                                <div class="col-8">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>
                            <div class="row" v-else-if="sprm.consecutive_cnt == 0">
                                <div class="text-center">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>
                            <p class="reserve05__time text-end d-none" v-if="parseInt(sprm.consecutive_cnt) > 0">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }} : </span>¥{{ number_format(cal_room_price(node)) }}
                            </p>
                            <p class="reserve05__time text-end d-none" v-else-if="parseInt(sprm.consecutive_cnt) == 0">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }} : </span>¥{{ number_format(node.sub_price) }}
                            </p>
                            <p class="reserve05__time text-end d-none">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('定員') }} : </span>{{node.category_param_1 }}
                            </p>
                            <p class="reserve05__time text-end">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('定員') }} : </span>{{ get_use_num_range_label(node.category_group_id) }}
                            </p>
                            <p class="reserve05__time text-end">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('広さ') }} : </span>{{node.category_param_2 }}
                            </p>
                            <ul class="reserve05__members border-top border-dark pt-3" v-for="(member, member_index) in node.members" :key="member">
                                <li class="reserve05__member d-flex align-items-center mb-1" >
                                    <div class="reserve05__label">{{ word_chg('予約詳細') }}</div>
                                    <div class="reserve05__memberType">
                                        <div class="members-inquiry__data mb-2" v-for="(ledger, l_idx) in ledger_type_list(node.category_id)" :key="l_idx">
                                            <!-- 入力値名称 -->
                                            <label
                                                :for="'Ledger_' + member_index + '_' + l_idx"
                                                v-if="ledger.is_user_view == 1"
                                                class="form-label"
                                            >
                                                <span class="text-danger" v-if="ledger.is_user_require==1">※</span>       
                                                {{ ledger.label }}</label>
                                            <!-- 入力値説明 -->
                                            <div v-if="ledger.user_description">
                                                <p style="font-size: 1.5rem;padding-bottom: 1rem;">{{ word_chg(ledger.user_description) }}</p>
                                            </div>
                                            <!-- 入力値テキスト系 -->
                                            <div v-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)" class="mb-2">
                                                <span v-if="['member_name', 'member_number'].includes(ledger.relation_column)">
                                                    <input :type="'hidden'" v-model="member.ledger[l_idx].value" class="" >
                                                    {{ member.ledger[l_idx].value }}
                                                </span>
                                                <input :type="ledger.input_type" v-model="member.ledger[l_idx].value" class="" v-else>
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ['textarea'].includes(ledger.input_type)" class="mb-2">
                                                <textarea v-model="member.ledger[l_idx].value" class="" rows="5"></textarea>
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) && ledger.default_param && typeof ledger.default_param === 'object'" class="mb-2">
                                                <bs-select
                                                    :options="ledger.default_param"
                                                    v-model="member.ledger[l_idx].value"
                                                    :null-option="true"
                                                    :id="'Ledger_' + member_index + '_' + l_idx"
                                                    class="reserveRunSearch__select"
                                                    >
                                                </bs-select>
                                            </div>
                                            <div v-else-if="ledger.is_user_view == 1 && ['plus_minus'].includes(ledger.input_type)" class="mb-2">
                                                
                                                <div class="row">
                                                    <div class="col text-center">
                                                        <button @click="subtractLedgerPM(l_idx, member_index, node_index)" class="btn btn-light btn-outline-secondary"><i class="bi bi-dash"></i></button>
                                                    </div>
                                                    <div class="col text-center">
                                                        {{member.ledger[l_idx].value}} 
                                                    </div>
                                                    <div class="col text-center">
                                                        <button @click="addLedgerPM(
                                                            l_idx, 
                                                            member_index, 
                                                            node_index,
                                                            get_use_num_param(node.category_group_id, 'high')
                                                            )" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button></div> 
                                                    <!-- <div class="col text-center">
                                                        <button @click="addLedgerPM(
                                                            l_idx, 
                                                            member_index, 
                                                            node_index, 
                                                            get_use_num_max(node.category_group_id, node_index)
                                                            )" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button></div>  -->
                                                    <!-- <div class="col text-center">
                                                        <button @click="addLedgerPM(l_idx, member_index, node_index, parseInt(node.category_param_1))" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button></div> -->
                                                </div>

                                            </div>
                                            <div v-else-if="ledger.is_user_view == 0">
                                                <input type="hidden" v-model="member.ledger[l_idx].value">
                                            </div>
                                        </div>

                                        <div class="" v-if="cal_room_price_plan(node_index) > 0">
                                            <label class="form-label">{{ word_chg('室料') }}</label>
                                            <div>¥ {{ number_format(cal_room_price_plan(node_index)) }} </div>
                                        </div>
                                        <div class="" v-if="getLedgerPrice(member) > 0">
                                            <label class="form-label">{{ word_chg('オプション料金') }}</label>
                                            <div><span v-if="member.price>0">¥</span>{{ getLedgerPrice(member) }} </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <p class="reserve05__addMember border-top border-dark py-3 d-none">
                                <a class="reserve05__addMemberLink" @click="addMember(node)">＋ {{ word_chg('宿泊者を追加する') }}</a>
                            </p>
                        </li>
                    </ul>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getRoomPriceTotalPlan) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('室料合計') }}:</span>¥{{ number_format(getRoomPriceTotalPlan) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getLedgerPriceTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('オプション金額') }}:</span>¥{{ number_format(getLedgerPriceTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getServicePriceTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('サービス料') }}:</span>¥{{ number_format(getServicePriceTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getVaTaxTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('消費税') }}:</span>¥{{ number_format(getVaTaxTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getBathingTaxTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('入湯税') }}:</span>¥{{ number_format(getBathingTaxTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1 mb-2" 
                        v-if="parseInt(getPriceTotal) > 0"
                    >
                        <span style="font-size: 1.4rem;" class="pe-3">{{ word_chg('合計金額') }}:</span><span style="font-size: 2.1rem;" class="">¥ {{ number_format(getPriceTotal) }}</span>
                    </p>
                    <div 
                        class="row mb-4" 
                    >
                        <div class="col offset-2">
                            <h5>【キャンセルポリシー】</h5>
                            <p>
                                当日&nbsp;100％<br>
                                前日&nbsp;80％<br>
                                2～5日前まで&nbsp;30％<br>
                                6日前まで&nbsp;10％
                            </p>
                        </div>
                    </div>


                    <p class="reserve05__submit">
                        <button class="button02" @click="confirm">{{ word_chg('予約内容を確認する') }}</button>
                    </p>
                </div>
            </div>
            <div v-else-if="reserve_step == 100">
                <div class="fullContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev(10)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">{{ sprm.date }}</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="customContainer mb-4 ">
                    <!-- PlanContents -->
                    <div class="row mb-3 pb-3 border-bottom border-dark" v-if="typeof get_plan_obj(target_plan) === 'object'">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">{{ get_plan_obj(target_plan).subject }}</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                {{ get_plan_obj(target_plan).price_head_label }}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="w-100">
                                
                            </div>
                            <img src="https://www.img-ikyu.com/contents/common/image/acc6/00002956/1/org/12488903.jpg?auto=compress,format&lossless=0&w=560&h=370">
                        </div>
                        <div class="col-9">
                            <p style="font-size: 1.3rem;white-space: pre-line;">
                                {{ get_plan_obj(target_plan).body }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="customContainer">
                    <ul class="reserve05__reserves">
                        <li class="reserve05__reserve" v-for="(node, node_index) in reserve_node" :key="node">
                            <h3 class="reserve05__title">
                                {{ node.category_group_label }}
                            </h3>
                            <div class="row" v-if="sprm.consecutive_cnt > 0">
                                <div class="col-4 text-end" v-html="word_chg_html('チェックインS')"></div>
                                <div class="col-8">{{ sprm.date }}</div>
                                <div class="col-4 text-end" v-html="word_chg_html('チェックアウトS')"></div>
                                <div class="col-8">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>
                            <div class="row" v-else-if="sprm.consecutive_cnt == 0">
                                <div class="text-center">{{ list_val_set(sprm.consecutive_cnt, reserve_stay_num) }}</div>
                            </div>

                            <p class="reserve05__time text-end d-none" v-if="parseInt(sprm.consecutive_cnt) > 0">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }}</span> : ¥{{ number_format(cal_room_price(node)) }}
                            </p>
                            <p class="reserve05__time text-end d-none" v-else-if="parseInt(sprm.consecutive_cnt) == 0">
                                <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }}</span> : ¥{{ number_format(node.sub_price) }}
                            </p>
                            <ul class="reserve05__members border-top border-dark pt-3" v-for="(member, index) in node.members" :key="member">
                                <li class="reserve05__member d-flex align-items-center mb-1" >
                                    <div class="reserve05__label">{{ word_chg('予約詳細') }}</div>
                                    <div class="reserve05__memberType">
                                        <div class="members-inquiry__data mb-2" v-for="(ledger, l_idx) in ledger_type_list(node.category_id)" :key="l_idx">
                                            <label
                                                :for="'Ledger_' + index + '_' + l_idx"
                                                v-if="ledger.is_user_view == 1"
                                                class="form-label"
                                            >
                                            <span class="text-danger" v-if="ledger.is_user_require==1">※</span>
                                                {{ word_chg(ledger.label) }}</label>

                                            <div v-if="ledger.is_user_view == 1 && ['text', 'number', 'date'].includes(ledger.input_type)" class="mb-2">
                                                {{ member.ledger[l_idx].value }}
                                            </div>
                                            <div v-if="ledger.is_user_view == 1 && ['texarea'].includes(ledger.input_type)" class="mb-2">
                                                {{ member.ledger[l_idx].value }}
                                            </div>
                                            <div v-if="ledger.is_user_view == 1 && ['select'].includes(ledger.input_type) && ledger.default_param && typeof ledger.default_param === 'object'" class="mb-2">
                                                {{ list_val_set(member.ledger[l_idx].value, ledger.default_param) }}
                                            </div>
                                            <div v-if="ledger.is_user_view == 1 && ['plus_minus'].includes(ledger.input_type)" class="mb-2">
                                                {{ member.ledger[l_idx].value }}
                                            </div>
                                        </div>

                                        <div class="" v-if="cal_room_price_plan(node_index) > 0">
                                            <label class="form-label">{{ word_chg('室料') }}</label>
                                            <div>¥ {{ number_format(cal_room_price_plan(node_index)) }} </div>
                                        </div>
                                        <div class="" v-if="getLedgerPrice(member) > 0">
                                            <label class="form-label">{{ word_chg('オプション料金') }}</label>
                                            <div><span v-if="member.price>0">¥</span>{{ getLedgerPrice(member) }} </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getRoomPriceTotalPlan) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('室料合計') }}:</span>¥{{ number_format(getRoomPriceTotalPlan) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getLedgerPriceTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('オプション金額') }}:</span>¥{{ number_format(getLedgerPriceTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getVaTaxTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('消費税') }}:</span>¥{{ number_format(getVaTaxTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getServicePriceTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('サービス料') }}:</span>¥{{ number_format(getServicePriceTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getBathingTaxTotal) > 0"
                    >
                        <span style="font-size: 1.3rem;" class="pe-3">{{ word_chg('入湯税') }}:</span>¥{{ number_format(getBathingTaxTotal) }}
                    </p>
                    <p 
                        class="reserve05__submit text-end py-1" 
                        v-if="parseInt(getPriceTotal) > 0"
                    >
                        <span style="font-size: 1.4rem;" class="pe-3">{{ word_chg('合計金額') }}:</span><span style="font-size: 2.1rem;" class="">¥{{ number_format(getPriceTotal) }}</span>
                    </p>
                    <div 
                        class="row mb-4" 
                    >
                        <div class="col offset-2">
                            <h5>【キャンセルポリシー】</h5>
                            <p>
                                当日&nbsp;100％<br>
                                前日&nbsp;80％<br>
                                2～5日前まで&nbsp;30％<br>
                                6日前まで&nbsp;10％
                            </p>
                        </div>
                    </div>
                    <p class="reserve05__submit">
                        <button class="button02" @click="reservation_plan">{{ word_chg('予約する') }}</button>
                    </p>
                </div>

            </div>
            <div v-else-if="reserve_step == 1">
                <div class="customContainer mb-3">
                    <div class="reserveRunSearch">
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name" v-html="word_chg_html('チェックインS')">
                            </div>
                            <div class="reserveRunSearch__item reserveRunSearch__item--date">
                                <p class="reserveRunSearch__dateP01">
                                    <input class="reserveRunSearch__date" type="date" v-model="sprm.date" @change="searchNode()"/>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name" v-html="word_chg_html('チェックアウトS')">
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="reserve_stay_num"
                                        v-model="sprm.consecutive_cnt"
                                        :null-option="false"
                                        id="ReserveStay"
                                        class="reserveRunSearch__select"
                                        @parentFunc="searchNode()"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <p class="reserveRunSearch__search">
                            <!-- {{ sprm.reserve_num }}/{{ sprm.consecutive_cnt }} -->
                            <button class="button02 button02--gray reserveRunSearch__searchButton" @click="searchNode">{{ word_chg('検索') }}</button>
                        </p>
                    </div>
                </div>

                <div class="customContainer" >
                    <!-- {{ node }} -->
                    <!-- <p>PlanContents1</p> -->
                    <!-- {{ plan_list }} -->

                    <div class="row mb-3 pb-3 border-bottom border-dark" v-for="plan in plan_list" :key="plan">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">{{ plan.subject }}</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                {{ plan.price_head_label }}
                            </div>
                        </div>
                        <div class="col-3 mb-2" v-if="typeof get_plan_asset(plan.id, 0) === 'object'">
                            <img :src="get_plan_asset(plan.id, 0).path">
                        </div>
                        <div class="col-6 mb-2">
                            <p style="font-size: 1.3rem;white-space: pre-line;">
                                {{ plan.body }}
                            </p>
                        </div>
                        <div class="col-3 mb-2 text-end">
                            <div @click="selectedPlanNext(plan.id)" class="arrow_link w-100 h-100 text-center">
                                <span class="d-inline-block fs-5 mb-4">{{ word_chg('予約を進める') }}</span>
                                <span class="d-inline-block "><i class="bi bi-chevron-right"></i></span>
                            </div>
                        </div>
                        <div class="col-12" v-if="typeof get_plan_asset_list(plan.id) ==='object' && Object.keys(get_plan_asset_list(plan.id)).length > 1">
                            <div class="row">
                                <div class="col-3 text-end" v-for="asset in get_plan_asset_list(plan.id)" :key="asset">
                                    <img :src="asset.path">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row mb-3 pb-3 border-bottom border-dark" v-for="a in 3" :key="a">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">【お試しホテルステイ】年中楽しめるオールシーズンプール完備！全室オーシャンビュー＜食事なし＞</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                ¥90,000
                            </div>
                        </div>
                        <div class="col-3">
                            <img src="https://www.img-ikyu.com/contents/common/image/acc6/00002956/1/org/12488903.jpg?auto=compress,format&lossless=0&w=560&h=370">
                        </div>
                        <div class="col-6">
                            <p style="font-size: 1.3rem;">
                                早期予約75日前】空港から約20分の好立地<br>全室オーシャンビューのビーチリゾート<br>朝食付
                            </p>
                        </div>
                        <div class="col-3 text-end">
                            <div @click="selectedPlanNext()" class="arrow_link w-100 h-100 text-center">
                                <span class="d-inline-block fs-5 mb-4">{{ word_chg('予約を進める') }}</span>
                                <span class="d-inline-block "><i class="bi bi-chevron-right"></i></span>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row mb-3 pb-3 border-bottom border-dark">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">部屋のみのご予約</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                ¥90,000
                            </div>
                        </div>
                        <div class="col-9 text-end">
                        </div>
                        <div class="col-3 text-end">
                            <div @click="selectedPlanNext()" class="arrow_link w-100 h-100 text-center">
                                <span class="d-inline-block fs-5 mb-4">{{ word_chg('予約を進める') }}</span>
                                <span class="d-inline-block "><i class="bi bi-chevron-right"></i></span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="customContainer d-none">
                    <div>
                        <p 
                            v-if="chk_selected_plan"
                            class="reserve-stay-reserve-inner__reserve border-bottom border-dark pb-4">
                            <button class="button02" @click="selectedPlanNext()">{{ word_chg('予約を進める') }}</button>
                        </p>
                        <p class="reserve04__button" v-else>
                            {{ word_chg('プランを選択してください。') }}
                        </p>
                    </div>
                </div>

            </div>
            <div v-else-if="reserve_step == 100000">
                    <!-- {{ sprm.date }}
                    {{ reserve_stay_num }} -->

                <div class="fullContainer">
                    <div class="calendarPager">
                        <div class="customContainer">
                            <ul class="calendar__ul d-flex align-items-center justify-content-between">
                                <li class="calendarPager__button ">
                                    <a class="calendarPager__link calendarPager__link--prev " @click="prev((production_chk)? 1: 1)">
                                        <i class="bi bi-chevron-left"></i>
                                    </a>
                                </li>
                                <li class="calendarPager__date">{{ sprm.date }}</li>
                                <li class="calendarPager__button "></li>
                            </ul>
                        </div>
                    </div>
                    <div class="py-4">
                        <br>
                        <span class="text-danger">※</span>{{ word_chg('は必須項目です。') }}
                    </div>
                </div>
                <div class="customContainer mb-4 ">
                    <!-- PlanContents -->
                    <div class="row mb-3 pb-3 border-bottom border-dark" v-if="typeof get_plan_obj(target_plan) === 'object'">
                        <div class="col-8 pb-2 mb-2">
                            <div style="font-size: 1.7rem;">{{ get_plan_obj(target_plan).subject }}</div>
                        </div>
                        <div class="col-4 pb-2 mb-2">
                            <div class="text-end">
                                {{ get_plan_obj(target_plan).price_head_label }}
                            </div>
                        </div>
                        <div class="col-3">
                            <img src="https://www.img-ikyu.com/contents/common/image/acc6/00002956/1/org/12488903.jpg?auto=compress,format&lossless=0&w=560&h=370">
                        </div>
                        <div class="col-9">
                            <p style="font-size: 1.3rem;white-space: pre-line;">
                                {{ get_plan_obj(target_plan).body }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="customContainer mb-4 d-none">
                    <div class="reserveRunSearch">
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name" v-html="word_chg_html('チェックインS')">
                            </div>
                            <div class="reserveRunSearch__item reserveRunSearch__item--date">
                                <p class="reserveRunSearch__dateP01">
                                    <input class="reserveRunSearch__date" type="date" v-model="sprm.date" @change="searchNode()"/>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-flex">
                            <div class="reserveRunSearch__name" v-html="word_chg_html('チェックアウトS')">
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="reserve_stay_num"
                                        v-model="sprm.consecutive_cnt"
                                        :null-option="false"
                                        id="ReserveStay"
                                        class="reserveRunSearch__select"
                                        @parentFunc="searchNode()"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <div class="reserveRunSearch__row d-none">
                            <div class="reserveRunSearch__name">
                                <label for="ReserveNum">{{ word_chg('人数') }}</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="reserve_num_list"
                                        v-model="sprm.reserve_num"
                                        :null-option="false"
                                        id="ReserveNum"
                                        class="reserveRunSearch__select"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <p class="reserveRunSearch__more d-none">
                            <a class="reserveRunSearch__moreLink" @click="sprmFrmDetailToggle" v-if="sprmFrmDetailSw">▲ {{ word_chg('閉じる') }}</a>
                            <a class="reserveRunSearch__moreLink" @click="sprmFrmDetailToggle" v-else>▼ {{ word_chg('もっと詳しく設定する') }}</a>
                        </p>
                        <div class="reserveRunSearch__row d-none" v-if="sprmFrmDetailSw">
                            <div class="reserveRunSearch__name">
                                <label for="CategoryId">Paddock</label>
                            </div>
                            <div class="reserveRunSearch__item">
                                <p>
                                    <bs-select
                                        :options="lodge_node_category_group"
                                        v-model="sprm.category_group_id"
                                        :null-option="true"
                                        id="CategoryId"
                                        class="reserveRunSearch__select"
                                    ></bs-select>
                                </p>
                            </div>
                        </div>
                        <p class="reserveRunSearch__search">
                            <!-- {{ sprm.reserve_num }}/{{ sprm.consecutive_cnt }} -->
                            <button class="button02 button02--gray reserveRunSearch__searchButton" @click="searchNode">{{ word_chg('検索') }}</button>
                        </p>
                    </div>
                </div>

                <div class="fullContainer">
                    <hr class="reserve04__border">
                </div>
                <div class="customContainer">
                    <div class="text-center my-3">
                        Paddock
                    </div>
                </div>
                <div class="customContainer">
                    <div class="row">
                        <div class="col-6 mb-4" v-for="node in lodge_reserv_category_plan" :key="node">
                            <div 
                            :class="groupIncludeStyle(node.category_group_id)" >
                                <p class="reserve-stay-reserve-inner__title">
                                    <span>{{node.category_group_id}}:{{ node.category_group_label }}</span>
                                    <!-- <span class="d-inline-block w-100 text-right">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('定員') }} : </span>{{ node.category_param_1 }}</span> -->
                                    <span class="d-inline-block w-100 text-right">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('定員') }} : </span>{{ get_use_num_range_label(node.category_group_id) }}</span>
                                    <span class="d-inline-block w-100 text-right">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('広さ') }} : </span>{{ node.category_param_2 }}</span>
                                </p>
                                <div class="reserve-stay-reserve-inner__reserve pb-4">
                                    <div>
                                        <span class="btn btn-light btn-outlien-secondary rounded-pill py-3 px-5 fs-5" @click="addGroupAndTapNext(node.category_group_id, node.count)">{{ word_chg('予約を進める') }}</span>
                                    </div>
                                </div>
                                <div class="reserve-stay-reserve-inner__reserve pb-4 d-none">
                                    <div v-if="!chkGroupInclude(node.category_group_id)">
                                        <span class="btn btn-light btn-outlien-secondary rounded-pill py-3 px-5 fs-5" @click="selectGroup(node.category_group_id)">{{ word_chg('選択する') }}</span>
                                    </div>
                                    <div v-else-if="chkGroupInclude(node.category_group_id)">
                                        <span class="fs-5">(選択中)</span><br>
                                        <span class="mb-2">予約数を選択</span>
                                        <div class="row">
                                            <div class="col">
                                                <button @click.stop="delGroup(node.category_group_id)" class="btn btn-light btn-outline-secondary"><i class="bi bi-dash"></i></button>
                                            </div>
                                            <div class="col">
                                                {{selected_category_group_num[node.category_group_id]}} {{ word_chg('棟') }}
                                            </div>
                                            <div class="col">
                                                <button @click.stop="addGroup(node.category_group_id, node.count)" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="customContainer d-none">
                    <!-- {{ selected_category_group_num }} -->
                    <div class="row">
                        <div class="col-6 mb-4" v-for="node in lodge_reserv_category" :key="node">
                            <div 
                            :class="groupIncludeStyle(node.category_group_id)" >
                                <p class="reserve-stay-reserve-inner__title">
                                    <span>{{ node.category_group_label }}</span>
                                    <span class="d-inline-block w-100 text-right" v-if="parseInt(sprm.consecutive_cnt) > 0">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }} : </span>¥{{ number_format(cal_room_price(node)) }}</span>
                                    <span class="d-inline-block w-100 text-right" v-else-if="parseInt(sprm.consecutive_cnt) == 0">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('室料') }} : </span>¥{{ number_format(node.sub_price) }}</span>
                                    <span class="d-inline-block w-100 text-right">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('定員') }} : </span>{{ node.category_param_1 }}</span>
                                    <span class="d-inline-block w-100 text-right">
                                        <span style="font-size: 1.3rem;" class="ps-3">{{ word_chg('広さ') }} : </span>{{ node.category_param_2 }}</span>
                                </p>
                                <div class="reserve-stay-reserve-inner__reserve pb-4">
                                    <div v-if="!chkGroupInclude(node.category_group_id)">
                                        <span class="btn btn-light btn-outlien-secondary rounded-pill py-3 px-5 fs-5" @click="selectGroup(node.category_group_id)">{{ word_chg('選択する') }}</span>
                                    </div>
                                    <div v-else-if="chkGroupInclude(node.category_group_id)">
                                        <span class="fs-5">(選択中)</span><br>
                                        <span class="mb-2">予約数を選択</span>
                                        <div class="row">
                                            <div class="col">
                                                <button @click.stop="delGroup(node.category_group_id)" class="btn btn-light btn-outline-secondary"><i class="bi bi-dash"></i></button>
                                            </div>
                                            <div class="col">
                                                {{selected_category_group_num[node.category_group_id]}} {{ word_chg('棟') }}
                                            </div>
                                            <div class="col">
                                                <button @click.stop="addGroup(node.category_group_id, node.count)" class="btn btn-light btn-outline-secondary"><i class="bi bi-plus"></i></button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p 
                            v-if="Object.keys(selected_category_group).length > 0"
                            class="reserve-stay-reserve-inner__reserve border-bottom border-dark pb-4">
                            <button class="button02" @click="tapNext()">{{ word_chg('予約を進める') }}</button>
                        </p>
                        <p class="reserve04__button" v-else>
                            {{ word_chg('予約枠を選択してください。') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .arrow_link {
        border: solid 1px #999;
        border-radius: 3px;
        padding-top: 2rem;
        padding-bottom: 2.2rem;
        font-size: 1.68rem;
        line-height: 1em;
        letter-spacing: .2em;
        text-decoration: none;
    }
    .arrow_link_btn {
    position: absolute;
    right: 4px;
    top: 40%;
    display: inline-block;
    content: "";
    width: 15px;
    height: 15px;
    border-top: 2px solid #969696;
    border-right: 2px solid #969696;
    transform: rotate(45deg);
    }
</style>
<script>
import reserveHeader from '../../organisms/BsReserveHeader.vue';
import BsSelect from '../../atoms/BsSelect.vue'
// import BsSelectNum from '../../atoms/BsSelectNum.vue'
// import BsRadio from '../../atoms/BsRadio.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import config from '../../../const'
import axios from 'axios'

export default {
    name: 'LodgingView',
    data: function () {
        return {
            sprm: {
                date: moment().format("YYYY-MM-DD"),
                day: moment().format("D"),
                reserve_num: 1,
                consecutive_cnt: 1,
                category_id: 0,
                is_guest: false
            },
            sprmFrmDetailSw: false,
            selected_node_ids: [],
            selected_category_group: [],
            selected_category_group_num: {},

            reserve_step: 1,

            reserve_node: [],
            lodge_node: [],
            add_friend_list: [],
            date_type_obj: [],
            plan_obj: [],
            target_plan: 0,
        }
    },
    props: {
        // param_reserve_num: {
        //     type: Number,
        //     // default: 1
        // },
        // param_category_id: {
        //     type: Number,
        //     // default: 1
        // },
    },
    components: {
        reserveHeader,
        BsSelect,
        // BsSelectNum,
        // BsRadio,
    },
    methods: {
        selectedPlanNext(plan_id){
            this.reserve_step = 100000;
            this.target_plan = plan_id;
        },
        selectPlan(node_id, plan_id){
            const tmp = this.reserve_node;
            const target_index = tmp.findIndex(node=>node.id==node_id);
            const target = {...tmp[target_index]};
            target.selected_plan = plan_id;
            tmp.splice(target_index, 1, target);
            this.reserve_node = tmp;

        },
        subtractLedgerPM(l_index, m_index, n_index){
            const node = (typeof this.reserve_node === 'object' && this.reserve_node[n_index])? this.reserve_node[n_index]: false;
            if(
                node != false && typeof node.members === 'object' 
                && typeof node.members[m_index] === 'object' && typeof node.members[m_index].ledger === 'object' 
                && typeof node.members[m_index].ledger[l_index] === 'object' 
                && parseInt(node.members[m_index].ledger[l_index].value) > 0
            ){
                node.members[m_index].ledger[l_index].value = parseInt(node.members[m_index].ledger[l_index].value) - 1;
                this.reserve_node[n_index] = node;
            }

        },
        addLedgerPM(l_index, m_index, n_index, max){
            // console.log('addLedgerPM', l_index, m_index, n_index, max);
            const node = (typeof this.reserve_node === 'object' && this.reserve_node[n_index])? {...this.reserve_node[n_index]}: false;
            if(
                node != false && typeof node.members === 'object' 
                && typeof node.members[m_index] === 'object' && typeof node.members[m_index].ledger === 'object' 
                && typeof node.members[m_index].ledger[l_index] === 'object' 
                && (this.get_node_members_use_num(n_index) + 1) <= max
            ){
                node.members[m_index].ledger[l_index].value = parseInt(node.members[m_index].ledger[l_index].value) + 1;
                this.reserve_node[n_index] = node;
                // alert('node');
            }
        },
        // addLedgerPM(l_index, m_index, n_index, max){
        //     // console.log('addLedgerPM', l_index, m_index, n_index, max);
        //     const node = (typeof this.reserve_node === 'object' && this.reserve_node[n_index])? {...this.reserve_node[n_index]}: false;
        //     // console.log('addLedgerPM node', node);
        //     // console.log('addLedgerPM members', node.members[m_index]);
        //     // console.log('addLedgerPM ledger', node.members[m_index].ledger);

        //     // console.log('addLedgerPM ledger', l_index, node.members[m_index].ledger[l_index]);
        //     if(
        //         node != false && typeof node.members === 'object' 
        //         && typeof node.members[m_index] === 'object' && typeof node.members[m_index].ledger === 'object' 
        //         && typeof node.members[m_index].ledger[l_index] === 'object' 
        //         && parseInt(node.members[m_index].ledger[l_index].value) < max
        //     ){
        //         node.members[m_index].ledger[l_index].value = parseInt(node.members[m_index].ledger[l_index].value) + 1;
        //         this.reserve_node[n_index] = node;
        //         // alert('node');
        //     }
        // },
        updateNumFunc(target, newValue){
            console.log('updateNumFunc', target, newValue);
            [target] = newValue;
        },
        sprmFrmDetailToggle(){
            if(this.sprmFrmDetailSw){
                this.sprmFrmDetailSw = false;
            }
            else{
                this.sprmFrmDetailSw = true;
            }
        },
        addGroup(group_id, count){
            const tmp = {...this.selected_category_group_num};
            const cnt = (tmp[group_id])? parseInt(tmp[group_id]): 0;
            if(parseInt(count) > cnt){
                const up = cnt + 1;
                tmp[group_id] = up;
                this.selected_category_group_num = tmp;
            }
        },
        delGroup(group_id){
            const tmp = {...this.selected_category_group_num};
            const cnt = (tmp[group_id])? parseInt(tmp[group_id]): 0;
            if(cnt > 0){
                const up = cnt - 1;
                tmp[group_id] = up;
                this.selected_category_group_num = tmp;
                if(up === 0){
                    const sel = [...this.selected_category_group];
                    if (sel.indexOf(group_id) >= 0){
                        sel.splice(sel.indexOf(group_id), 1);
                    }
                    this.selected_category_group = sel;
                }
            }
        },
        selectGroup(group_id){
            const tmp = this.selected_category_group;
            if(tmp.indexOf(group_id) < 0){
                tmp.push(group_id);
                this.selected_category_group_num[group_id] = 1;
            // }else if (tmp.indexOf(group_id) >= 0){
            //     tmp.splice(tmp.indexOf(group_id), 1);
            //     this.selected_category_group_num[group_id] = 0;
            }
            console.log('selectGroup', tmp);
            this.selected_category_group = tmp;
            console.log('selectGroup', this.selected_category_group);
        },
        chkGroupInclude(group_id){
            const tmp = this.selected_category_group;
            if(tmp.indexOf(group_id) < 0){
                return false;
            }else if (tmp.indexOf(group_id) >= 0){
                return true;
            }
        },

        addGroupAndTapNext(group_id, count){
            const tmp = {...this.selected_category_group_num};
            const cnt = (tmp[group_id])? parseInt(tmp[group_id]): 0;
            if(parseInt(count) > cnt){
                const up = cnt + 1;
                tmp[group_id] = up;
                this.selected_category_group_num = tmp;
            }
            this.tapNext();
        },
        tapNext(){
            // 
            // 予約可能nodeを作る。
            this.selected_node_ids = [];
            const nodes = [];
            if(
                typeof this.node_category_group === 'object' && Object.keys(this.node_category_group).length > 0
            ){
                Object.values(this.node_category_group).forEach(group => {
                    if(
                        typeof this.lodge_node === 'object' && Object.keys(this.lodge_node).length > 0 && 
                        this.lodge_node.find(node => {return node.category_group_id == group.id})
                    ){
                        const tcnt = this.lodge_node.filter(node => {
                            if(node.category_group_id == group.id){
                                return true;
                            }else{
                                return false;
                            }
                        });
                        console.log('tapNext tcnt', tcnt);
                        if(typeof tcnt === 'object' && Object.keys(tcnt).length > 0){
                            Object.values(tcnt).forEach(list => {
                                nodes.push(list);
                            })
                        }
                    }
                })
            }
            console.log('tapNext nodes', nodes);
            console.log('tapNext selected_category_group_num', this.selected_category_group_num);
            if(
                nodes.length > 0 && 
                typeof this.selected_category_group_num === 'object' && Object.keys(this.selected_category_group_num).length > 0
            ){
                Object.keys(this.selected_category_group_num).forEach(group_id => {
            console.log('tapNext group_id', group_id);
                    const num = parseInt(this.selected_category_group_num[group_id]);
            console.log('tapNext num', num);
                    if(
                        num > 0 && 
                        nodes.find(node => {return node.category_group_id == group_id})
                    ){
                        let count = 0;
            console.log('tapNext count', count);
                        Object.values(nodes).filter(node => {
            console.log('tapNext node', node);
                            if(node.category_group_id == group_id && num > count){
                                count += 1;
                                this.selected_node_ids.push(node.id);
                            }
                        })
                    }
                });
            }
            console.log('tapNext selected_node_ids', this.selected_node_ids);
            this.next();
        },
        tapNode(node_id){
            console.log('tapNode', node_id);
            if(!this.selected_node_ids.includes(node_id)){
                this.selected_node_ids = [...[node_id]];
            }
            else{
                this.selected_node_ids = [...[node_id]];
            }
            this.next();
        },
        changeCustomerType(member){
            console.log('changeCustomerType', member.target);
            if(
                member.ledger
                && Object.keys(member.ledger).length > 0
            ){
                // Object.values(member.ledger).forEach(ledger => {
                //     ledger.value = '';
                // });
                member.ledger.map(led =>{
                    led.value = '';
                });
            }
            if(member.target == 1){
                member.use_m_id = this.$store.state.auth.userId;
            }else{
                member.use_m_id = 0;
            }
        },
        // 予約
        // addMember(node){
        //     const node_id = node.id;

        //     const form = {...this.memberFrm};
        //     form.node_id = node_id;

        //     const ltmps = [];
        //     if(this.ledger_type){
        //         Object.values(this.ledger_type).forEach(ledger => {
        //             const ltmp = {
        //                 id: 0,
        //                 stat: 1,
        //                 reservation_node_id: 0,
        //                 node_id: 0,
        //                 type_id: ledger.id,
        //                 value: ''
        //             }
        //             ltmps.push({...ltmp});
        //         });
        //     }

        //     form.ledger = [...ltmps];

        //     if(form && form.ledger && Object.keys(form.ledger).length > 0){
        //         Object.keys(form.ledger).forEach(key => {
        //             form.ledger[key].node_id = node_id;
        //         });
        //     }
        //     // const targetNode = this.reserve_node.find(rnode => {
        //     //     return (rnode.id == node_id);
        //     // });
        //     // console.log('addMember', targetNode, node);
        //     // targetNode.members.push({...form});
        //     node.members.push({...form});
        // },

        addMember(node_id){
            // const node_id = node.id;
            const target_rsv_node = this.nodeExtractCp(node_id);
            // const target_rsv_node = {...this.reserve_node[node_index]};
            const members = [...target_rsv_node.members];
            // const node_id = target_rsv_node.id;

            const form = {...this.memberFrm};
            form.node_id = node_id;

            const ltmps = [];
            if(this.ledger_type_list(target_rsv_node.category_id)){
                Object.values(this.ledger_type_list(target_rsv_node.category_id)).forEach(ledger => {
                    const ltmp = {
                        id: 0,
                        stat: 1,
                        reservation_node_id: 0,
                        node_id: 0,
                        type_id: ledger.id,
                        relation_column: ledger.relation_column,
                        value: ''
                    }
                    if(ledger.relation_column == 'member_name'){
                        ltmp.value = this.getMyName;
                    }
                    if(ledger.relation_column == 'member_number'){
                        ltmp.value = this.getMyNumber;
                    }
                    if(ledger.relation_column == 'checkin_date'){
                        ltmp.value = this.sprm.date;
                    }
                    if(ledger.relation_column == 'checkout_date'){
                        ltmp.value = this.list_val_set(this.sprm.consecutive_cnt, this.reserve_stay_num);
                    }
                    if(ledger.input_type == 'plus_minus'){
                        ltmp.value = '0';
                    }
                    ltmps.push({...ltmp});
                });
            }

            form.ledger = [...ltmps];   

            if(form && form.ledger && Object.keys(form.ledger).length > 0){
                Object.keys(form.ledger).forEach(key => {
                    form.ledger[key].node_id = node_id;
                });
            }
            // const targetNode = this.reserve_node.find(rnode => {
            //     return (rnode.id == node_id);
            // });
            // console.log('addMember', targetNode, node);
            // targetNode.members.push({...form});
            members.push({...form});
            target_rsv_node.members = members;
            const node_index = this.reserve_node.findIndex(rsv_node => rsv_node.id == node_id);
            this.reserve_node[node_index] = target_rsv_node;
            // this.reserve_node = target_rsv_node;
            // node.members.push({...form});
        },
        addFriend(member, friend){
            // add_friend_listに重複してないか検査
            const chk = this.add_friend_list.find(data => {
                return (friend.id == data.id)
            });
            if(!chk){
                this.add_friend_list.push({
                    friend_id: friend.id,
                    friend_label: friend.true_name_label,
                    kbn_id: (friend.kbn.id)? friend.kbn.id: 0,
                    label: friend.true_name_label,
                    key: friend.id,
                });
                // const tmp = {...member}
                // tmp.use_m_id = friend.id;
                member.use_m_id = friend.id;
                // member = tmp;
                this.$forceUpdate();
            }
            else{
                alert('すでに登録済です');
            }
        },
        friendSearch(member){
            if(member.tmp_search_words.length <= 0){
                const msg_tgt = this.word_chg('検索ワード');
                const pre_tgt = this.word_chg('入力msg_Pre');
                const post_tgt = this.word_chg('入力msg_Post');
                alert(pre_tgt + msg_tgt + post_tgt);
                return;
            }

            const params = {};
            // params['stat'] = [1];
            params['search_words'] = member.tmp_search_words;
            axios.post(
                config.BASE_API_URL + '/member/lists',
                this.setParams_S(params),
                this.cHeader
            )
            .then(
                (response) => {
                    member.tmp_search_list = response.data.body;
                    console.log('then friendSearch', response);
                // if(this.dashboard.lodge_node) this.lodge_node = this.dashboard.lodge_node;
                }
            )
            .catch((err) => {
                console.log(err);
                // this.search_sales = [];
            })
            .finally(() => {
                console.log('finally friendSearch');
                this.$forceUpdate();
            });


        },

        // 検索
        async searchNode(){
            // console.log('searchNode !!');
            await this.loadLodgePriceType();
            await this.loadLodgingPriceTypeData();
            await this.loadPlan();
            await this.loadLodgeNode();
        },

        // load
        loadUser(){
            const params = {};
            params['id'] = this.$store.state.auth.userId;
            console.log('params', params);
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
            .catch((err) => {
            console.log(err);
            Promise.reject(err)
            })
            .then(() => {})
            .finally(() => {});
        },
        async loadLodgePriceType () {
            const params = {};
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'lodge_price_type'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('lodge_price_type');
                        })
                        .finally(() => {});
        },
        loadLodgeCategory() {
            const params = {};
            params['stat'] = 1;
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'lodge_node_category'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {});
        },
        loadCategoryGroup() {
            const params = {};
            params['stat'] = 1;
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'node_category_group'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {});
        },
        loadLedgerType(){
            const params = {};
            params['stat'] = 1;
            params['type'] = 'lodge';
            return this.$store.dispatch('fetchBasicLists', {data: params, target: 'ledger_type'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                        })
                        .finally(() => {
                            // console.log(' sex', this.$store.state.apidata.sex);
                        })

        },
        async loadLodgingPriceTypeData () {
            const params = {};
            params['stat'] = '[1]';
            params['calendar_date_lower2'] = moment(this.sprm.date).add(parseInt(this.sprm.consecutive_cnt), 'd').format('YYYY-MM-DD')
            params['calendar_date_higher'] = this.sprm.date;
            params['pagelimit'] = false;
            // console.log('loadLodgeNode params', params);

            axios.post(
                config.BASE_API_URL + '/node_calendar_price/lists',
                this.setParams_S(params),
                this.cHeader
            )
            .then(
                (response) => {
                    console.log('loadLodgingPriceTypeData then response', response);
                    this.date_type_obj = (response.data.body)? 
                        response.data.body: [];
                })
            .catch(
                (err) => {
                Promise.reject(err);
                console.log(err);
                this.date_type_obj = [];
                }
            );
            // return this.$store.dispatch('fetchBasicLists', {data: params, target: 'lodge_node'});
        },
        async loadPlan () {
            const params = {};
            params['node_type'] = 'lodge';
            params['stat'] = [1];
            params['consecutive_cnt'] = this.sprm.consecutive_cnt;
            // checkin out
            params['checkin_term'] = {
                checkin_date: this.sprm.date,
                checkout_date: moment(this.sprm.date).add(parseInt(this.sprm.consecutive_cnt), 'd').format('YYYY-MM-DD')
            };
            
            axios.post(
                config.BASE_API_URL + '/plan/lists',
                this.setParams_S(params),
                this.cHeader
            )
            .then(
                (response) => {
                    this.plan_obj = response.data.body;
                    console.log('then plan_obj', response);
                // if(this.dashboard.lodge_node) this.lodge_node = this.dashboard.lodge_node;
                }
            )
            .catch((err) => {
                console.log(err);
                this.plan_obj = [];
            })
            .finally(() => {
                console.log('finally plan_obj');
                this.$forceUpdate();
            });
        },
        async loadLodgeNode () {
            console.log('loadLodgeNode');
            const params = {};
            params['node_type'] = 'lodge';
            params['stat'] = [1];
            params['reserved_count'] = 0;
            params['is_owner'] = 0;
            if(this.sprm.category_group_id) params['category_ids'] = this.node_category_group_category_ids(this.sprm.category_group_id);
            params['range_start_date'] = this.sprm.date;
            params['range_end_date'] = this.sprm.date;
            params['consecutive_cnt'] = this.sprm.consecutive_cnt;
            const now_date = moment().format('YYYY-MM-DD HH:mm:ss');
            params['release_start_date'] = now_date;
            params['release_end_date'] = now_date;
            params['accept_start_date'] = now_date;
            params['accept_end_date'] = now_date;

            axios.post(
                config.BASE_API_URL + '/lodge_node/lists',
                this.setParams_S(params),
                this.cHeader
            )
            .then(
                (response) => {
                    this.lodge_node = response.data.body;
                    console.log('loadLodgeNode then lodge_node', response);
                // if(this.dashboard.lodge_node) this.lodge_node = this.dashboard.lodge_node;
                }
            )
            .catch((err) => {
                console.log(err);
                this.lodge_node = [];
            })
            .finally(() => {
                console.log('finally lodge_node');
                this.$forceUpdate();
            });
            // console.log('searchNode loadLodgeNode params', params);
            // return this.$store.dispatch('fetchBasicLists', {data: params, target: 'lodge_node'})
            //             .catch(err => Promise.reject(err))
            //             .then(() => {
            //                 console.log('loadLodgeNode complete lodge_node');
            //                 console.log('this', this.$store.state.apidata.lodge_node);
            //             })
            //             .finally(() => {
            //                 // console.log('searchNode finally', this.$store.state.apidata.lodge_node);
            //             })
        },



        guest_input_form_sw_action(){
            if(this.guest_input_form_sw){
                this.guest_input_form_sw = false;
            }else{
                this.guest_input_form_sw = true;
            }
        },
        confirm(){
            let check = true;
            const msg = [];
            if(typeof this.reserve_node === 'object' && this.reserve_node.length > 0){
                this.reserve_node.forEach(node => {
                    if(parseInt(node.reserve_num) <= 0){
                        check = false;
                        msg.push('人数を入力してください。');
                    }
                    if(node.members && typeof node.members === 'object'){
                        node.members.forEach(member => {
                            // if(member.target == '' || parseInt(member.target) <= 0){
                            //     check = false;
                            //     msg.push(this.word_chg('宿泊者を選択してください。'));
                            // }
                            console.log('confirm chk node.members member', member);
                            if(
                                typeof this.ledger_type_list(node.category_id) === 'object'
                                && this.ledger_type_list(node.category_id).length > 0
                            ){
                                Object.values(this.ledger_type_list(node.category_id)).forEach(ledger_type_data => {
                                    console.log('confirm chk ledger_type_data', ledger_type_data);
                                    const ledger_id = (typeof ledger_type_data === 'object' && ledger_type_data.id)? ledger_type_data.id: false;
                                    console.log('confirm chk ledger_id', ledger_id, member.ledger);
                                    const member_ledger = (typeof member.ledger === 'object')?
                                        member.ledger.find(ld => {return ld.type_id == ledger_id}): false;
                                    console.log('confirm chk member_ledger', member_ledger);
                                    if(
                                        ledger_type_data.is_user_view == '1' 
                                        && ledger_type_data.is_user_require == '1'
                                        ){
                                    console.log('confirm chk member_ledger 1,1,', member_ledger);
                                        if(member_ledger != false && member_ledger.value == ''){
                                            console.log('confirm chk ledger_type ', ledger_type_data);
                                            console.log('confirm chk ledger ', member_ledger);
                                            let lmsg = '';
                                            if(ledger_type_data && ledger_type_data.label){
                                                lmsg += this.word_chg(ledger_type_data.label);
                                            }
                                            console.log('confirm chk guest alert 0', ledger_id, member.target, ledger_type_data, lmsg);

                                            // if(parseInt(ledger_type_data.id) == 1 && parseInt(member.target) == 200){
                                            if(parseInt(ledger_type_data.id) == 1 ){
                                                console.log('confirm chk guest alert', ledger_id, member.target, lmsg);
                                                // check = true;
                                            }else{
                                                console.log('confirm chk parseInt(ledger_type_data.id)', parseInt(ledger_type_data.id));
                                                check = false;
                                                msg.push(lmsg + this.word_chg('は必須項目です。'));
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }else{
                check = false;
                msg.push(this.word_chg('予約枠が設定されていません。'));
            }
            if(!check){
                // let message = '';
                if(msg.length > 0){
                    // msg.forEach(m => {
                    //     message += this.word_chg(m) + ',';
                    // })
                    alert(msg.join('\n'));
                }
                // alert(message);
            }else{
                window.scrollTo(0, 0);
                this.reserve_step = 100;
            }
        },
        next(){
            // 予約申し込み用オブジェクト
            this.reserve_node = [];
            this.selected_node_ids.forEach(node_id => {
                const node = this.nodeExtract(node_id);
                console.log('next node', node_id, node);
                node['reserve_num'] = (typeof this.sprm === 'object' && (typeof this.sprm.reserve_num === 'string' || typeof this.sprm.reserve_num === 'number'))? parseInt(this.sprm.reserve_num): 1;
                this.reserve_node.push(node);
                if(
                    node.members && Object.keys(node.members).length < parseInt(node['reserve_num'])
                ){
                    const cnt = parseInt(this.sprm.reserve_num) - Object.keys(node.members).length;
                    for(let i=0;i<cnt;i++){
                        this.addMember(node.id);
                    }
                }
                else if(
                    node.members && Object.keys(node.members).length > parseInt(node['reserve_num'])
                ){
                    // const cnt = Object.keys(node.members).length - parseInt(this.sprm.reserve_num);
                    for(let i=Object.keys(node.members).length;i>parseInt(node['reserve_num']);i--){
                        this.delMember(node.id,i);
                    }
                }
            });
            console.log('next reserve_node', this.reserve_node);
            window.scrollTo(0, 0);
            this.reserve_step = (this.production_chk)? 10: 10;
        },
        // next(){
        //     // 予約申し込み用オブジェクト
        //     this.reserve_node = [];
        //     this.selected_node_ids.forEach(node_id => {
        //         this.reserve_node.push(this.nodeExtract(node_id));
        //         this.addMember(this.nodeExtract(node_id));
        //     });

        //     this.reserve_step = 10;
        // },
        prev(step){
            if(
                step == 100000
            ){
                this.selected_category_group_num = {}
            }
            this.reserve_step = step;
        },
        reservation_plan(){
            const user = this.getMyData;
            // console.log('reservation reserve_node', this.reserve_node, user);
            const params = {};
            params['m_id'] = this.$store.state.auth.userId;
            params['node_type'] = 'lodge';
            // params['consecutive_cnt'] = this.sprm.consecutive_cnt;
            if(Object.keys(this.reserve_node).length > 0){
                // params['node'] = this.reserve_node;
                const reservation = [];
                let reserv_obj = {};
                let consecutive_ids_ = [];
                const rsvNode = [];
                Object.values(this.reserve_node).forEach(node => {
                    rsvNode.push(node.category_group_id);
                    if(node.members && Object.keys(node.members).length > 0){
                        Object.values(node.members).forEach(member => {
                            const ledger_data = [];
                            if(member.ledger && Object.keys(member.ledger).length > 0){
                                Object.values(member.ledger).forEach(ledger => {
                                    ledger['node_id'] = node.id;
                                    ledger['sel_ledger'] = this.get_ledger_type_data(ledger.type_id);
                                    ledger_data.push(ledger);
                                });
                            }
                            consecutive_ids_ = (node.consecutive_ids)? [node.id].concat(node.consecutive_ids): [];
                            reserv_obj = {
                                reservation_id: 0,
                                consecutive_ids: consecutive_ids_,
                                // consecutive_cnt: ,
                                consecutive_price: node.consecutive_price,
                                group_label: node.category_group_label,
                                node_id: node.id,
                                plan_id: this.target_plan,
                                plan_label: (typeof this.get_plan_obj(this.target_plan) === 'object')? this.get_plan_obj(this.target_plan).subject: '',
                                use_m_id: user.id,
                                kbn_id: (user.kbn && user.kbn.id)? user.kbn.id: 0,
                                checkin_id: 0,
                                use_guest_id: member.use_guest_id,
                                is_use: 0,
                                is_guest: member.is_guest,
                                is_cancel: 0,
                                is_sub_price: (parseInt(this.sprm.consecutive_cnt) > 0)? 0: 1,
                                price: 0,
                                ledger: ledger_data,
                                note: {}
                            };
                        });
                    }
                });
                // get_checkin_date_price_type_price_value(node.category_group_id, get_node_members_use_num(node_index))
                if(
                    typeof rsvNode === 'object'
                ){
                    Object.keys(rsvNode).forEach(node_index => {
                        if(
                            typeof this.get_checkin_date_price_type_price_value(rsvNode[node_index], this.get_node_members_use_num(node_index)) === 'object'
                            && typeof consecutive_ids_ === 'object'
                        ){
                            console.log('reservation get_checkin_date_price_type_price_value node_index', node_index, reserv_obj);
                            this.get_checkin_date_price_type_price_value(rsvNode[node_index], this.get_node_members_use_num(node_index)).forEach(obj => {
                                console.log('reservation params use_num ', obj);
                                const tmp = {...reserv_obj};
                                tmp.node_id = consecutive_ids_.shift()
                                tmp.price = obj.price_value;

                                reservation.push(tmp);
                            })
                        }
                    })
                }
                
                params['reserve'] = reservation;
            }
            console.log('reservation params', params);
            // return true;
            return this.$store.dispatch('updateBasic', {data: params, target: 'reservation'})
                .then((response) => {
                    if(typeof response === 'object'){
                        if(response.data.alert.title == 'SUCCESS'){
                            alert('予約が完了しました');
                            // this.back()
                        }else{
                            alert('予約できませんでした');
                            this.alertMessage = response.data.alert.message;
                            this.alertClass = response.data.alert.addClass;
                        }
                    }else{
                        alert('予約できませんでした');
                    }
                })
                .catch(
                    () => {
                    err => Promise.reject(err);
                        alert('予約できませんでした');
                    }
                )
                .finally(() => {
                    // this.$refs.closeRsvModal.click();
                    this.$forceUpdate();
                    // this.$refs.closeNodeModalParent.click();
                    this.$router.push({ path: '/' })
                });

        },
        reservation(){
            const user = this.getMyData;
            // console.log('reservation reserve_node', this.reserve_node, user);
            const params = {};
            params['m_id'] = this.$store.state.auth.userId;
            params['node_type'] = 'lodge';
            params['consecutive_cnt'] = this.sprm.consecutive_cnt;
            if(Object.keys(this.reserve_node).length > 0){
                // params['node'] = this.reserve_node;
                const reservation = [];
                Object.values(this.reserve_node).forEach(node => {
                    if(node.members && Object.keys(node.members).length > 0){
                        Object.values(node.members).forEach(member => {
                            const ledger_data = [];
                            if(member.ledger && Object.keys(member.ledger).length > 0){
                                Object.values(member.ledger).forEach(ledger => {
                                    ledger['node_id'] = node.id;
                                    ledger['sel_ledger'] = this.get_ledger_type_data(ledger.type_id);
                                    ledger_data.push(ledger);
                                });
                            }
                            console.log('reservation params ledger_data', ledger_data);
                            const consecutive_ids_ = (node.consecutive_ids)? node.consecutive_ids: [];
                            // const price = this.getLedgerPrice(member);
                            // const price = this.getPriceTotal;
                            // console.log('reservation params price', price);
                            // member.price = price;
                            const node_price = node.price;
                            reservation.push({
                                reservation_id: 0,
                                consecutive_ids: consecutive_ids_,
                                consecutive_cnt: this.sprm.consecutive_cnt,
                                consecutive_price: node.consecutive_price,
                                group_label: node.category_group_label,
                                node_id: node.id,
                                plan_id: this.target_plan,
                                use_m_id: user.id,
                                kbn_id: (user.kbn && user.kbn.id)? user.kbn.id: 0,
                                checkin_id: 0,
                                use_guest_id: member.use_guest_id,
                                is_use: 0,
                                is_guest: member.is_guest,
                                is_cancel: 0,
                                is_sub_price: (parseInt(this.sprm.consecutive_cnt) > 0)? 0: 1,
                                price: node_price,
                                ledger: ledger_data,
                                note: {}
                            });
                        });
                    }
                });
                params['reserve'] = reservation;
            }
            console.log('reservation params', params);

            return this.$store.dispatch('updateBasic', {data: params, target: 'reservation'})
                .then((response) => {
                    if(typeof response === 'object'){
                        if(response.data.alert.title == 'SUCCESS'){
                            alert('予約が完了しました');
                            // this.back()
                        }else{
                            alert('予約できませんでした');
                            this.alertMessage = response.data.alert.message;
                            this.alertClass = response.data.alert.addClass;
                        }
                    }else{
                        alert('予約できませんでした');
                    }
                })
                .catch(
                    () => {
                    err => Promise.reject(err);
                        alert('予約できませんでした');
                    }
                )
                .finally(() => {
                    // this.$refs.closeRsvModal.click();
                    this.$forceUpdate();
                    // this.$refs.closeNodeModalParent.click();
                    this.$router.push({ path: '/' })
                });
        }
    },
    computed: {
        ...mapState({
            lodge_node_category: state => state.apidata.lodge_node_category,
            kbn_list: state => state.apidata.member_kbn,
            // lodge_node: state => state.apidata.lodge_node,
            ledger_type: state => state.apidata.ledger_type,
            user: state => state.apidata.user,
            node_category_group: state => state.apidata.node_category_group,
            lodge_price_type: state => state.apidata.lodge_price_type,
        }),
        // get_use_num_max: function(){
        //     const get_use_num_param = this.get_use_num_param;
        //     const get_node_members_use_num = this.get_node_members_use_num;
        //     return function(category_group_id, node_index){
        //         const total_max = get_use_num_param(category_group_id, 'high');
        //         const count = get_node_members_use_num(node_index);
        //         return total_max - count;
        //     }
        // },
        get_node_from_reserve_node_index: function(){
            // node.members
            const nodes = this.reserve_node;
            return function(node_index){
                return (typeof nodes === 'object' && typeof nodes[node_index] === 'object')? nodes[node_index]: false;
            }
        },
        get_node_members_use_num: function(){
            // node.members
            const get_func = this.get_node_from_reserve_node_index;
            return function(node_index){
                if(
                    typeof get_func(node_index) === 'object'
                    && typeof get_func(node_index).members === 'object'
                    && typeof get_func(node_index).members[0] === 'object'
                    && typeof get_func(node_index).members[0].ledger === 'object'
                ){
                    let use_num = 0;
                    get_func(node_index).members[0].ledger.forEach(led => {
                        if(
                            ['adult_male', 'adult_female', 'child_teen', ].includes(led.relation_column)
                            && parseInt(led.value) > 0
                        ){
                            use_num += parseInt(led.value);
                        }
                    })
                    return use_num;
                }
                return 0;
            }
        },
        get_plan_asset_list: function(){
            const get_func = this.get_plan_obj;
            return function(plan_id){
                if(
                   typeof get_func(plan_id) === 'object' 
                   && typeof get_func(plan_id).assets === 'object' 
                ){
                    return get_func(plan_id).assets
                }
                return false;
            }
        },
        get_plan_asset: function(){
            const get_func = this.get_plan_asset_list;
            return function(plan_id, plan_index){
                if(
                   typeof get_func(plan_id) === 'object' 
                   && typeof get_func(plan_id)[plan_index] === 'object'
                ){
                    return get_func(plan_id)[plan_index];
                }
                return false;
            }
        },
        get_plan_obj: function(){
            const plan_list = this.plan_list;
            return function(plan_id){
                if(
                    plan_list.find(plan => plan.id == plan_id)
                ){
                    return plan_list.find(plan => plan.id == plan_id);
                }
                return false;
            }
        },
        get_use_num_param: function(){
            const get_func = this.get_relations_from_category_group;
            return function(category_group_id, param){
                let high = 0;
                let low = 0;
                get_func(category_group_id).forEach(rel => {
                    if(
                        parseInt(rel.use_num) > high
                    ){
                        high = parseInt(rel.use_num);
                    }
                    if(
                        low == 0 || parseInt(rel.use_num) <= low
                    ){
                        low = parseInt(rel.use_num);
                    }
                });
                if(
                    param == 'high'
                ){
                    return high;
                }
                else if(
                    param == 'low'
                ){
                    return low;
                }
                else if(
                    param == 'range'
                ){
                    return {
                        low: low,
                        high: high
                    }
                }
                return '';
            }
        },
        get_use_num_range_label: function(){
            const get_func = this.get_use_num_param;
            return function(category_group_id){
                if(
                    typeof get_func(category_group_id, 'range') === 'object'
                ){
                    const high = get_func(category_group_id, 'range').high;
                    const low = get_func(category_group_id, 'range').low;
                    let range_label = '';
                    range_label += (parseInt(low) > 0)? '' + low + '': '';
                    if(
                        high > low
                    ){
                        range_label += '名 〜 ';
                        range_label += high;
                    }
                    if(range_label != '') range_label += '名';
                    return range_label;
                }
                return '';
            }
        },
        get_relations_from_category_group: function(){
            const relations = this.get_relations_sort_plan_and_price_type;
            return function(category_group_id){
                return relations.filter(rel => rel.category_group_id == category_group_id)
                .sort((a, b) => {
                    if(parseInt(a.sort) < parseInt(b.sort)){
                        return -1;
                    }else{
                        return 1;
                    }
                });
            }
        },
        get_relations_sort_plan_and_price_type: function(){
            if(
                parseInt(this.target_plan) > 0 
                && typeof this.get_plan_obj(this.target_plan) === 'object'
                && typeof this.get_plan_obj(this.target_plan).relations === 'object'
                && parseInt(this.sprm.consecutive_cnt) > 0
            ){
                // const checkin_date_list = this.get_checkin_date_price_type;
                // for(let c=0;c<=parseInt(this.sprm.consecutive_cnt);c++){
                //     checkin_date_list.push(moment(this.sprm.date).add(parseInt(c), 'd').format('YYYY-MM-DD'))
                // }
                return this.get_plan_obj(this.target_plan).relations.filter(
                    rel => {
                        if(
                            this.get_checkin_date_price_type.find(obj => obj.price_type == rel.price_type)
                        ){
                            return true;
                        }
                        return false;
                    }
                );
            }
            return [];
        },
        get_checkin_date_price_type: function(){
            const tmps = [];
            if(
                parseInt(this.sprm.consecutive_cnt) > 0
            ){
                for(let c=0;c<parseInt(this.sprm.consecutive_cnt);c++){
                    const chk_date = moment(this.sprm.date).add(parseInt(c), 'd').format('YYYY-MM-DD');
                    tmps.push({
                        date: chk_date,
                        price_type: this.chk_date_type_price_type(chk_date)
                    })
                }
            }
            // console.log('plan_obj get_checkin_date_price_type tmps', tmps);
            return tmps;
        },
        get_checkin_date_price_type_price_value: function(){
            const get_checkin_date_price_type = this.get_checkin_date_price_type;
            const get_relations_from_category_group = this.get_relations_from_category_group;
            return function(category_group_id, use_num){
                console.log('reservation get_checkin_date_price_type_price_value', category_group_id, use_num);
                if(
                    use_num <= 0
                ){
                    return [];
                }
                return get_checkin_date_price_type.map(obj => {
                    if(
                        get_relations_from_category_group(category_group_id).find(grp => (grp.price_type == obj.price_type && grp.use_num == use_num))
                    ){
                        obj.price_value = get_relations_from_category_group(category_group_id).find(grp => (grp.price_type == obj.price_type && grp.use_num == use_num)).price_value;
                    }
                    return obj;
                });
            }
        },
        chk_date_type_obj: function(){
            const date_type = this.date_type_obj;
            return function(date){
            console.log('plan_obj chk_date_type_obj date_type', date_type, date);
                if(
                    typeof date_type === 'object'
                    && date_type.find(type => type.calendar_date == date)
                ){
                    return date_type.find(type => type.calendar_date == date);
                }
                return false;
            }
        },
        chk_date_type_price_type: function(){
            const get_func = this.chk_date_type_obj;
            return function(date){
                if(
                    get_func(date)
                ){
                    return get_func(date).price_type;
                }
                return false;
            }
        },
        lodge_node_category_ids: function(){
            const tmps = [];
            if(
                typeof this.lodge_node === 'object'
            ){
                this.lodge_node.forEach(node => {
                    if(
                        tmps.indexOf(node.category_id) < 0
                    ){
                        tmps.push(node.category_id);
                    }
                })
            }
            return tmps;
        },
        plan_list: function(){
            // const tmps = [];
            if(
                typeof this.plan_obj === 'object'
            ){
                console.log('plan_obj plan_list CCC1', this.plan_obj, this.get_checkin_date_price_type);

                const tmps = this.plan_obj.filter(plan => {
                    if(
                        typeof plan.relations === 'object'
                        && Object.keys(plan.relations).length > 0
                        && typeof this.get_checkin_date_price_type === 'object'
                        && Object.keys(this.get_checkin_date_price_type).length > 0
                    ){
                        if(
                            Object.values(this.get_checkin_date_price_type.filter(type => {
                                console.log("plan_obj plan_list pricetype", type);
                                if(
                                    type.price_type != false 
                                    && plan.relations.find(rel => {
                                        if(
                                            rel.price_type == type.price_type
                                        ){
                                            return true;
                                        }
                                        return false;
                                    })
                                ){
                                    return true;
                                }
                                return false;
                            })).length == Object.keys(this.get_checkin_date_price_type).length 
                            // && plan.relations.filter(rel => {
                            //     if(rel.category_ids.filter(category_id => {
                            //         if(this.lodge_node_category_ids.indexOf(category_id) >= 0){
                            //             return true;
                            //         }
                            //         return false;
                            //     })){
                            //         return true;
                            //     }
                            //     return false;
                            // }, this.lodge_node_category_ids)
                        ){
                            return true;
                        }
                    }
                    return false;
                })
                console.log('plan_obj plan_list CCC tmps', tmps, this.get_checkin_date_price_type);
                return tmps.map(plan => {
                    let price_high = 0;
                    let price_low = 0;
                    let price_head_label = '';
                    plan.relations.forEach(rel => {
                        if(
                            parseInt(rel.use_num) == 1
                            && parseInt(rel.price_value) > price_high
                        ){
                            price_high = parseInt(rel.price_value);
                        }
                        if(
                            parseInt(rel.use_num) == 1
                            && (price_low == 0 || parseInt(rel.price_value) <= price_low)
                        ){
                            price_low = parseInt(rel.price_value);
                        }
                    });
                    price_head_label += (parseInt(price_low) > 0)? '¥' + this.number_format(price_low) + '': '';
                    if(
                        price_high > price_low
                    ){
                        price_head_label += '〜';
                        price_head_label += '¥';
                        price_head_label += this.number_format(price_high);
                    }
                    plan['price_head_label'] = price_head_label;
                    return plan;
                })
            }
            return [];
        },
        chk_selected_plan: function(){
            const selected_plan_nodes = this.reserve_node.filter(node => (node.selected_plan != '' && parseInt(node.selected_plan) >= 0));
            if(
                typeof selected_plan_nodes === 'object'
                && selected_plan_nodes.length == this.reserve_node.length
            ){
                return true;
            }else{
                return false;
            }
        },
        plan_class_chk: function(){
            const reserve_node = this.reserve_node;
            return function(node_id, plan_id){
                const target_node = reserve_node.find(node => node.id == node_id);
                if(
                    typeof target_node === 'object' 
                    && target_node !== undefined
                    && target_node.selected_plan
                    && target_node.selected_plan != '0'
                    && target_node.selected_plan == plan_id
                ){
                    return true;
                }
                return false;
            }
        },
        plan_class: function(){
            const base = 'btn rounded-pill py-3 px-5 fs-5';
            const chk = this.plan_class_chk;
            return function(node_id, plan_id){
                if(
                    chk(node_id, plan_id)
                ){
                    return base + ' btn-info';
                }
                return base + ' btn-light btn-outlien-secondary';
            }
        },
        plan_btn_label: function(){
            const chk = this.plan_class_chk;
            return function(node_id, plan_id){
                if(
                    chk(node_id, plan_id)
                ){
                    return '選択中'
                }
                return '選択する'
            }
        },
        production_chk: function(){
            if(this.vue_node_env == 'production'){
                return true;
            }
            else{
                return false;
            }
        },
        cal_room_price_plan: function(){
            const get_relations_from_category_group = this.get_relations_from_category_group;
            const get_node_members_use_num = this.get_node_members_use_num;
            const get_node_from_reserve_node_index = this.get_node_from_reserve_node_index;
            const get_checkin_date_price_type = this.get_checkin_date_price_type;
            return function(node_index){
                const node = get_node_from_reserve_node_index(node_index);
                const use_num = get_node_members_use_num(node_index);
                let price_value = 0;
                if(
                    typeof node === 'object'
                    && node.category_group_id > 0
                ){
                    get_checkin_date_price_type.forEach(obj => {
                        if(
                            typeof get_relations_from_category_group(node.category_group_id) === 'object'
                        ){
                            typeof get_relations_from_category_group(node.category_group_id).forEach(rel => {
                                if(
                                    rel.use_num == use_num 
                                    && rel.price_type == obj.price_type
                                    && parseInt(rel.price_value) > 0
                                ){
                                    price_value += parseInt(rel.price_value)
                                }
                            })
                        }
                    })

                }
                return price_value;
            }
        },
        cal_room_price: function(){
            const c_cnt = parseInt(this.sprm.consecutive_cnt);
            return function(node){
                if(c_cnt < 2){
                    return parseInt(node.price);
                }else if(
                    typeof node.consecutive_price === 'object' 
                    && Object.keys(node.consecutive_price).length > (c_cnt - 1)
                ){
                    const price_c_cnt = node.consecutive_price.slice(0, (c_cnt - 1));
                    let price = parseInt(node.price);
                    Object.values(price_c_cnt).forEach(c_price => {
                        price += parseInt(c_price);
                    })
                    return price;
                }
                return 0;
            }
        },
        getPaddockRsvNum: function(){
            const group_num = this.selected_category_group_num;
            return function(group_id){
                if(group_num[group_id]){
                    return group_num;
                }else{
                    return 0;
                }
            }
        },
        facility_group_id: {
            get: function (){
                if(this.search_disp_sw){
                    return this.facility_group_id_st;
                }else{
                    return this.facility_group_id_obj;
                }
            },
            set: function(value){
                if(this.search_disp_sw){
                    this.facility_group_id_st = value;
                }else{
                    this.$emit('to_push_select_date', value);
                }
            }
        },
        getPaddockRsvNumList: function(){
            return function(count){
                const tmps = [];
                if(parseInt(count) > 0){
                    for(let i=1;i<=parseInt(count);i++){
                        tmps.push({
                            key: i,
                            label: i + this.word_chg('棟')
                        })
                    }
                }
                return tmps;
            }
        },
        groupIncludeStyle: function(){
            const sel_cate_g = this.selected_category_group;
            return function(group_id){
                const css_style = 'p-2 border border-3 rounded-2 ';
                if(sel_cate_g.includes(group_id)){
                    return css_style + 'border-primary bg-info';
                }else{
                    return css_style + 'border-dark';
                }
            }
        },
        lodge_reserv_category_plan: function(){
            const plan_obj = this.get_plan_obj(this.target_plan);
            const tmps = this.lodge_reserv_category.filter(node => {
                if(
                    typeof plan_obj === 'object'
                    && typeof plan_obj.relations === 'object'
                    && plan_obj.relations.find(rel => {
                        if(
                            rel.category_group_id == node.category_group_id
                        ){
                            return true
                        }
                    })
                ){
                    return true;
                }
                return false;
            })
            // .map(node => {
                
            // });
            return tmps;
        },
        lodge_reserv_category: function(){
            const tmps = [];
            if(
                typeof this.node_category_group === 'object' && Object.keys(this.node_category_group).length > 0
            ){
                Object.values(this.node_category_group).forEach(group => {
                    if(
                        typeof this.lodge_node === 'object' && Object.keys(this.lodge_node).length > 0 && 
                        this.lodge_node.find(node => {return (node.category_group_id == group.id && node.consecutive_cnt >= this.sprm.consecutive_cnt)})
                    ){
                        const tmp = this.lodge_node.find(node => {return node.category_group_id == group.id});
                        // console.log('searchNode lodge_reserv_category consecutive_cnt', this.sprm.consecutive_cnt, tmp);
                        const tcnt = this.lodge_node.filter(node => {
                            if(node.category_group_id == group.id){
                                return true;
                            }else{
                                return false;
                            }
                        });
                        if(typeof tcnt === 'object'){
                            tmp.count = Object.keys(tcnt).length;
                        }else{
                            tmp.count = 1;
                        }
                        tmps.push(tmp);
                    }
                })
            }
            return tmps;
        },

        ledger_type_list: function(){
            const target_type = this.ledger_type;
            return function(category_id){
                const filters = target_type.filter((type) => {
                    if(
                        typeof type === 'object' && typeof type.category_relation === 'object'
                        && type.category_relation.indexOf(category_id) >= 0
                    ){
                        return type;
                    }
                });
                return filters.sort((a, b) => {
                if(parseInt(a.sort) < parseInt(b.sort)){
                    return -1;
                }else{
                    return 1;
                }
            })
            }
        },

        node_information_message: function(){
            const tmps = [];
            if(
                typeof this.reserve_node === 'object' && Object.keys(this.reserve_node).length > 0
            ){
                Object.values(this.reserve_node).forEach(node => {
                    console.log('node_information_message', node);
                    if(node.information_message){
                        tmps.push(this.word_chg(node.information_message));
                    }
                })
            }
            return tmps;
        },
        reserve_num_list_node: function(){
            // const num_list = this.reserve_num_list;
            const rsv_node = this.reserve_node;
            return function(node_id){
                const target_node = rsv_node.find(n => {
                    return n.id == node_id;
                });
                const list = [];
                if(target_node && target_node.remain_count && parseInt(target_node.remain_count) > 0){
                    for(let i=1; i<=parseInt(target_node.remain_count);i++){
                        list.push({
                            label: i + ' ' + this.word_chg('select人'),
                            key: i
                        });
                    }
                }
                return list;
            }
        },
        list_val_set: function(){
            return function(val, options){
                console.log('list_val_set options', options);
                if(typeof options === 'object'){
                    const option = options.find((data) => {
                        return data.key == val;
                    })
                    return (typeof option === 'object')? this.word_chg(option.label): '';
                }
                return val;
            }
        },
        // axiosHeader: function(){
        //     return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
        // },
        // login user
        getMyData: function(){
            const mydata = this.user.find((data) => {
            return data.id == this.$store.state.auth.userId;
            })
            return mydata;
        },
        getMyName: function(){
            let name = '';
            if(this.getMyData){
                if(this.getMyData.name_1) name += this.getMyData.name_1;
                if(this.getMyData.name_2) name += this.getMyData.name_2;
                if(this.getMyData.name_3) name += this.getMyData.name_3;
            }
            return name;
        },
        getMyNumber: function(){
            let number = '';
            if(this.getMyData){
                if(this.getMyData.number) number += this.getMyData.number;
            }
            return number;
        },
        getFriendData: function(){
            if(this.getMyData.friendship){
                return this.getMyData.friendship;
            }
            return [];
        },
        addFriendData:function(){
            const tmps = [];
            if(this.add_friend_list){
                Object.values(this.add_friend_list).forEach(friend => {
                    tmps.push({
                        key: friend.id,
                        label: friend.true_name_label
                    })
                })
            }
            return tmps;
        },
        getFriendDataAddList: function(){
            const tmps = [...this.getFriendData];
            const tmps2 = [...this.addFriendData];
            tmps2.push({
                key: 0,
                label: '追加'
            });
            return [...tmps, ...tmps2];
        },
        getGuestData: function(){
            if(this.getMyData.guest){
                return this.getMyData.guest;
            }
            return [];
        },
        getGuestDataAddList: function(){
            const tmps = [...this.getGuestData];
            tmps.push({
                key: 0,
                label: '追加'
            });
            return tmps;
        },
        getCarData: function(){
            if(this.getMyData.cars){
                return this.getMyData.cars;
            }
            return [];
        },

        get_ledger_type_data: function(){
            const lt = this.ledger_type;
            return (target) => {
                const type = Object.values(lt).filter((value) => {
                if(value.id == target) return value;
            });
                return type[0];
            }
        },
        getBathingTaxTotal(){
            let total = 0;
            if(Object.keys(this.reserve_node).length > 0){
                Object.values(this.reserve_node).forEach(node => {
                    if(
                        node.members && Object.keys(node.members).length > 0
                        && parseInt(this.sprm.consecutive_cnt) > 0
                    ){
                        Object.values(node.members).forEach(member => {
                            const tax =this.getLedgerBathingTax(member);
                            if(tax){
                                total = total + parseInt(tax);
                            }
                        });
                    }
                });
            }
            return total;
        },
        getVaTaxTotal(){
            const totalPrice = this.getRoomPriceTotalPlan + this.getLedgerPriceTotal + this.getServicePriceTotal;
            // const totalPrice = this.getRoomPriceTotal + this.getLedgerPriceTotal + this.getServicePriceTotal;
            return (totalPrice > 0)? Math.floor(totalPrice * 0.1): 0;
        },
        getServicePriceTotal(){
            // const roomPrice = this.getRoomPriceTotal;
            const roomPrice = this.getRoomPriceTotalPlan;
            return (roomPrice > 0)? Math.floor(roomPrice * 0.1): 0;
        },
        getPriceTotal(){
            let totalPrice = 0;
            // ルーム
            // totalPrice += this.getRoomPriceTotal;
            totalPrice += this.getRoomPriceTotalPlan;
            // オプション
            totalPrice += this.getLedgerPriceTotal;
            // サービス料
            totalPrice += this.getServicePriceTotal;
            // 入湯税
            totalPrice += this.getBathingTaxTotal;
            // 消費税
            totalPrice += this.getVaTaxTotal;

            return totalPrice;
        },
        getRoomPriceTotalPlan(){
            let totalPrice = 0;
            if(Object.keys(this.reserve_node).length > 0){
                Object.keys(this.reserve_node).forEach(node_index => {
                    totalPrice += (this.cal_room_price_plan(node_index));
                });
            }
            return parseInt(totalPrice);
        },
        getRoomPriceTotal(){
            let totalPrice = 0;

            if(Object.keys(this.reserve_node).length > 0){
                Object.values(this.reserve_node).forEach(node => {
                    if(parseInt(this.sprm.consecutive_cnt) > 0){
                        totalPrice  = totalPrice + (this.cal_room_price(node));
                    }else if(parseInt(this.sprm.consecutive_cnt) == 0 && parseInt(node.sub_price) > 0){
                        totalPrice  = totalPrice + parseInt(node.sub_price);
                    }
                });
            }
            return parseInt(totalPrice);
        },
        getLedgerPriceTotal(){
            let totalPrice = 0;
            if(Object.keys(this.reserve_node).length > 0){
                Object.values(this.reserve_node).forEach(node => {
                    if(node.members && Object.keys(node.members).length > 0){
                        Object.values(node.members).forEach(member => {
                            const price =this.getLedgerPrice(member);
                            if(price){
                                totalPrice = totalPrice + parseInt(price);
                            }
                        });
                    }
                });
            }
            return totalPrice;
        },
        getLedgerPrice:function(){
            return function(member){
                let sum_price = 0;
                if(
                    member && member.ledger && typeof member.ledger === 'object'
                    && Object.keys(member.ledger).length > 0
                ){
                    Object.values(member.ledger).forEach(mledger => {
                        if(mledger.type_id > 0 && mledger.value != ''){
                            const ltype = this.get_ledger_type_data(mledger.type_id);
                            if(ltype.default_param && typeof ltype.default_param === 'object'){
                                const dp = Object.values(ltype.default_param).filter((value) => {
                                    if(value.key == mledger.value) return value;
                                });
                                if(dp && typeof dp === 'object' && dp[0] && dp[0].price > 0){
                                    sum_price += parseInt(dp[0].price);
                                }
                            }
                        }
                    });
                }
                // member.price = sum_price;
                return sum_price;
            }
        },
        getLedgerBathingTax:function(){
            return function(member){
                console.log('getLedgerBathingTax');
                let sum_tax = 0;
                if(
                    member && member.ledger && typeof member.ledger === 'object'
                    && Object.keys(member.ledger).length > 0
                ){
                    console.log('getLedgerBathingTax 2');
                    const tax_param = ['adult_male', 'adult_female'];
                    Object.values(member.ledger).forEach(mledger => {
                        if(mledger.type_id > 0 && mledger.value != ''){
                            const ltype = this.get_ledger_type_data(mledger.type_id);
                            if(
                                ltype.relation_column && typeof ltype.relation_column === 'string'
                                && tax_param.includes(ltype.relation_column)
                            ){
                                sum_tax += parseInt(mledger.value) * 150;
                            }
                        }
                    });
                    console.log('getLedgerBathingTax 3', sum_tax);
                }
                // member.price = sum_price;
                    console.log('getLedgerBathingTax 4', sum_tax);
                return sum_tax;
            }
        },
        customerTypeList: function(){
            return function(is_guest){
                const list = [];
                list.push({
                    key: 1,
                    label: '本人'
                });
                list.push({
                    key: 100,
                    label: 'お友達'
                });
                // guest可能か
                if(is_guest != 'false'){
                    list.push({
                    key: 200,
                    label: 'ゲスト'
                    });
                }
                return list;
            }
        },
        memberFrm: function(){
            const form = {
                        id: 0,
                        stat: 0,
                        node_id: 0,
                        use_m_id: 0,
                        kbn_id: 0,
                        reservation_id: 0,
                        checkin_id: 0,
                        use_guest_id: 0,
                        is_use: 0,
                        is_cancel: 0,
                        price: 0,
                        is_guest: 0,
                        ledger: [],
                        note: {},
                        target: 0,
                        tmp_label: '',
                        tmp_tel: '',
                        tmp_search_words: '',
                        tmp_search_list:[],
            }
            return form;
        },
        member_type_list: function(){
            const list ={
                0: {
                    label: '会員',
                    value: 0,
                    key: 0
                },
                1: {
                    label: 'ゲスト',
                    value: 1,
                    key: 1
                },
            }
            return list;
        },
        node_available_reservation: function(){
            return function (item){
                return item;
            }
        },
        category_label: function(){
            const cate = this.lodge_node_category;
            return function(category_id){
                console.log('category_label', category_id, cate);
                if(Object.keys(cate).length > 0 && cate.find((val) =>{return val.id == category_id})){
                    const tmp = cate.find((val) =>{return val.id == category_id});
                    return tmp.label;
                }else{
                    return (category_id)? category_id: '';
                }
            }
        },
        lodge_node_category_group: function(){
            const groups = [];
            if(
                Object.keys(this.node_category_group).length > 0
            ){
                Object.values(this.node_category_group).forEach(group => {
                    if(this.lodge_node_category.find(cate => {return cate.group_id == group.id})){
                        groups.push(group);
                    }
                });
            }
            return groups;
        },
        node_category_group_category_ids: function(){
            // const groups = this.node_category_group;
            const lodge_node_category = this.lodge_node_category;
            return function(group_id){
                const category_ids = [];
                // if(lodge_node_category.find(cate => {return cate.group_id == group.id})){
                //     groups.push(group);
                // }
                if(
                    Object.keys(lodge_node_category).length > 0
                ){
                    Object.values(lodge_node_category).forEach(cate => {
                        if(cate.group_id == group_id){
                            category_ids.push(cate.id);
                        }
                    });
                }
                return category_ids;
            }
        },
        node_style: function(){
            const baseStyle = 'cursor: pointer;';
            return function(item){
                let style_ = 'background:';

                if(item.bg_color){
                    style_ += item.bg_color + ';';
                }
                else{
                    style_ += '#FFFFFF;';
                }
                style_ += 'color:';
                if(item.text_color){
                    style_ += item.text_color + ';';
                }
                else{
                    style_ += '#000000;';
                }
                if(
                    this.selected_node_ids.includes(item.node_id)
                ){
                    style_ += 'border: solid 2px #FF0000;margin:-2px;';
                }
                return baseStyle + style_ + '';
            }
        },
        node_p_style: function(){
            return function(item){
                if(item.time_diff > 20){
                    return '';
                }else{
                    return 'd-flex align-items-center justify-content-center';
                }
            }
        },
        node_class: function(){
            const baseClass = 'reserveTimeSchedule__label d-flex align-items-center justify-content-center  reserveTimeSchedule__label--';
            return function(item){
                let diff = '';
                if(parseInt(item.time_diff) > 20){
                    diff = '40';
                }
                else{
                    diff = 20;
                }
                return baseClass + diff + 'min';
            }
        },
        get_lodge_node_item: function(){
            const lodge_node = this.lodge_node;
            const target_date = this.sprm.date;
            // const target_day = this.sprm.day;
            return function (time, cols){
                const nodes = lodge_node.filter(node => {
                    return (node.range_start_date == target_date);
                })
                const tmps = [];
                Object.values(nodes).forEach(node => {
                    if(node.items && Object.keys(node.items).length > 0){
                        const items = node.items.filter(item => {
                // console.log('get_lodge_node_item', time, cols, cols.includes(parseInt(item.col_num)));
                            return (item.start_date_time == time && cols.includes(parseInt(item.col_num)));
                        });
                        if(Object.keys(items).length > 0){
                            Object.values(items).forEach(item => {
                                tmps.push(item);
                            });
                        }
                    }
                });
                return tmps;
            }
        },
        lodge_node_items: function(){
            const tmps = {};
            if(this.sprm.date){
                for(let i = 1;i<=moment(this.sprm.date).endOf('month').format('D');i++){
                    tmps[i] = {};
                }
                        // console.log('lodge_node_items length > obj', this.lodge_node);
                Object.keys(this.lodge_node).forEach((index) => {
                        console.log('lodge_node_items length > obj', this.lodge_node[index]);
                    if(Object.keys(this.lodge_node[index].items).length > 0){
                        console.log('lodge_node_items length > obj', this.lodge_node[index].items);
                        Object.keys(this.lodge_node[index].items).forEach(idx => {
                            if(
                                !tmps[this.lodge_node[index].items[idx].start_date_day_num][this.lodge_node[index].items[idx].start_date_sort_num]
                            ){
                                tmps[this.lodge_node[index].items[idx].start_date_day_num][this.lodge_node[index].items[idx].start_date_sort_num] = [];
                            }
                            tmps[this.lodge_node[index].items[idx].start_date_day_num][this.lodge_node[index].items[idx].start_date_sort_num].push(
                                this.lodge_node[index].items[idx]
                            );
                        });
                    }
                });
            }
            return tmps;
        },
        nodeItem:function(){
            const node_items = this.lodge_node_items;
            return function(day){
                const tmps = {};
                // console.log('getNode', node_id, this.target_day, target_date.format("YYYY-MM-DD"));
                if(day > 0 && node_items[day] && Object.keys(node_items[day]).length > 0){
                    const keys = Object.keys(node_items[day]);
                    keys.sort();
                    keys.forEach(key => {
                        tmps[key] = node_items[day][key];
                    });
                }
                return tmps;
            }
        },
        nodeExtract:function(){
            const nodes = this.lodge_node;
            return function(node_id){
                return nodes.find(node => {
                    return node.id == node_id;
                });
            }
        },
        nodeExtractCp:function(){
            const nodes = [...this.lodge_node];
            return function(node_id){
                return nodes.find(node => {
                    return node.id == node_id;
                });
            }
        },


        end_hour: function(){
            return 17
        },
        timesc_unit: function(){
            const unit_min = 20;
            const unit_p = Math.floor(60/unit_min);
            const start_hour = 8;
            const end_hour = this.end_hour;
            const units = [];
            for(let i=start_hour;i<end_hour;i++){
                for (let e = 0; e < unit_p; e++) {
                    const hourZ = (i<10)? '0' + i: i;
                    const minP = (e * unit_min);
                    const minZ = (minP<10)? '0' + minP: minP;
                    units.push(
                        {
                            label: hourZ + ':' + minZ,
                            hour: i,
                            min: minP
                        }
                    )
                }
            }
            return units;
        },
        reserve_stay_num: function(){
            const list = [];
            list.push({
                key: 0,
                label: this.word_chg('デイユース')
            });
            // moment(this.sprm.date).format("D");
            console.log('reserve_stay_num', this.sprm.date);
            const sprm_date = (typeof this.sprm.date === 'object')? this.sprm.date[0]: this.sprm.date;
            for(let i=1; i<=3;i++){
                const tmpd = moment(sprm_date);
            console.log('reserve_stay_num tmpd', tmpd, tmpd.format('YYYY-MM-DD'));
                const lbl = tmpd.add(i, 'd').format('YYYY-MM-DD');
            console.log('reserve_stay_num lbl', lbl);
                list.push({
                    label: lbl + '(' + i + this.word_chg('泊') + ')',
                    key: i
                });
            }
            return list;
        },
        reserve_num_list: function(){
            const list = [];
            for(let i=1; i<=6;i++){
                list.push({
                    label: i + '人',
                    key: i
                });
            }
            return list;
        },
    },
    async created () {
        if(this.$route.query.param_reserve_num) this.sprm.reserve_num = this.$route.query.param_reserve_num;
        if(this.$route.query.param_date){
            this.sprm.date = this.$route.query.param_date;
        }
        if(this.$route.query.param_category_id) this.sprm.category_id = this.$route.query.param_category_id;
        if(this.sprm.date){
            this.sprm.day = moment(this.sprm.date).format("D");
        }
        this.loadLodgeCategory();
        this.loadCategoryGroup();
        await this.loadLodgePriceType();
        await this.loadLodgingPriceTypeData();
        await this.loadPlan();
        await this.loadLodgeNode();
        this.loadUser();
        this.loadLedgerType();
      // this.sel_month = this.month_list[12].key;
    },
}
</script>
